/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 */

'use strict';

/**
 * @internal
 *
 * Helper to create a unique name for a handle field based on the handle name, handle key and
 * source field.
 */
function getRelayHandleKey(handleName, key, fieldName) {
  if (key && key !== require('./RelayDefaultHandleKey').DEFAULT_HANDLE_KEY) {
    return '__' + key + '_' + handleName;
  }

  !(fieldName != null) ? process.env.NODE_ENV !== 'production' ? require('fbjs/lib/invariant')(false, 'getRelayHandleKey: Expected either `fieldName` or `key` in `handle` to be provided') : require('fbjs/lib/invariant')(false) : void 0;
  return '__' + fieldName + '_' + handleName;
}

module.exports = getRelayHandleKey;


//////////////////
// WEBPACK FOOTER
// ./~/relay-runtime/lib/getRelayHandleKey.js
// module id = 526
// module chunks = 3